import {
    Processor,
    ValueObj
} from "@xapp/stentor-api-client/dist/services/rest/fetch/FetchHTTPClient";

/**
 * A processor that will remove all undefined or null values from
 * the object.
 *
 * @export
 * @template T
 * @returns {Processor<T>}
 */
export function removeUndefined<T extends ValueObj>(): Processor<T> {
    return (obj) => {
        const returnObj: Partial<T> = {};
        for (const key of Object.keys(obj)) {
            const value = obj[key as keyof T];
            // tslint:disable:no-null-keyword
            // checking ` != null` is the quickest and easiest way to check if undefined AND null.
            if (value != null) {
                returnObj[key as keyof T] = value;
            }
            // tslint:enable:no-null-keyword
        }
        return returnObj as T;
    };
}
